// extracted by css-extract-rspack-plugin
var _1 = "m2";
var _2 = "ni";
var _3 = "m0";
var _4 = "nj";
export { _1 as "label", _2 as "newsletterSettingsComponent", _3 as "settingRow", _4 as "wider" }
